export const validation = {
    isEmailAddress:function(str) {
        str = str.replace(/(\r\n\t|\n|\r\t)/gm,"");
        if(str === '') {
            return false
        }else {
            var pattern =/^[A-Za-z0-9](([_\.\+\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\+\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/;
            return pattern.test(str);  // returns a boolean
        }
    },
    isNotEmpty:function (str) {
        var pattern =/\S+/;
        return pattern.test(str);  // returns a boolean
    },
    isFullName: function (str) {
        var pattern = /^\s*([A-Za-z]{1,}([\.,] |[-']| ))+[A-Za-z]+\.?\s*$/;
        if(str.length > 100) {
            return false
        }
        return pattern.test(str)
    },
    isShortName: function (str) {
        if(str.length > 15) {
            return false
        }
        return true
    },
    isGender: function (str) {
        let lowerCaseStr = str.toLowerCase();
        if(lowerCaseStr === 'male' || lowerCaseStr === 'female' || lowerCaseStr === 'other' || lowerCaseStr === '') {
            return true
        }
        return false  // returns a boolean
    },
    isProperDate: function (str) {
        var pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        return pattern.test(str);  // returns a boolean
    },
    isCountryCode: function (str) {
        if(str !== '') {
            var pattern = /^[A-Z]{1,3}$/;
            return pattern.test(str)
        }else {
            return true
        }
    },
    isAlternateMail: function (str) {
        if(str !== '') {
            var pattern =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            return pattern.test(str);  // returns a boolean
        }else {
            return true
        }
    },
    isCity: function (str) {
        if(str !== ''){
            if(str.length > 100){
                return false
            }
            var pattern = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/
            return pattern.test(str)
        }else {
            return true
        }
    },
    isMobileNumber: function (str) {                
        if(str !== ''){
            var pattern = /^(\+\d{1,3}[- ]?)?\d{0,17}$/
            return pattern.test(str)
        }else {
            return true
        }
    },
    isWorkPhone: function (str) {
        if(str !== '') {
            var pattern = /^(\+\d{1,3}[- ]?)?\d{0,27}$/
            return pattern.test(str)
        }else {
            return true
        }
    },
    isOccupation: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }
            return true
        }else {
            return true
        }
    },
    isDesignation: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }
            return true
        }else {
            return true
        }
    },
    isWorkExperience: function (str) {
        if(str !== '') {
            var pattern = /^\d{1,2}(\.\d{1,4})?$/
            return pattern.test(str)
        }else {
            return true
        }
    },
    marriedState: function (str) {
        if(str !== '') {
            let lowerCaseStr = str.toLowerCase()
            if(lowerCaseStr === 'single' || lowerCaseStr === 'divorced' || lowerCaseStr === 'married' || lowerCaseStr === 'widow'){
                return true
            }else {
                return false
            }
        }else {
            return true
        }
    },
    sendNotification: function (str) {
        if(str !== '') {
            let lowerCaseStr = str.toLowerCase()
            if(lowerCaseStr === 'no' || lowerCaseStr === 'yes'){
                return true
            }else {
                return false
            }
        }else {
            return true
        }
    },
    numberOfChildren: function (str) {
        if(str !== '') {
            let numberStr = parseInt(str)
            if(numberStr > 50 || numberStr < 0) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },familyType: function (str) {
        if(str !== '') {
            let lowerCaseStr = str.toLowerCase()
            if(lowerCaseStr === 'nuclear' || lowerCaseStr === 'joint' || lowerCaseStr === 'extended'){
                return true
            }else {
                return false
            }
        }else {
            return true
        }
    },isHobbies: function (str){
        if(str !== ''){
            if(str.length > 500) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },annualIncome: function (str) {
        if(str !== '') {
            if(str === '< $100,000' || str === '$100,000 - $250,000' || str === '$250,000 - $500,000' || str === '$500,000 - $1million' || str === '> $1million' ){
                return true
            }else {
                return false
            }
        }else {
            return true
        }
    },isPreviousAssessment: function (str) {
        if(str !== ''){
            if(str.length > 500) {
                return false
            }else {
                return true
            }
        }else { 
            return true
        }
    },isDepartment: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },isLocation: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },highestEducation: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },isIndustry: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },isQualification: function (str) {
        if(str !== ''){
            if(str.length > 100) {
                return false
            }else {
                return true
            }
        }else {
            return true
        }
    },
    isNumber:function(str) {
        var pattern = /^\d+$/;
        return pattern.test(str);  // returns a boolean
    },
    isSame:function(str1,str2){
        return str1 === str2;
    },
    isTenureInCompany: function (str1, str2) {
        if(str1 !== '' && str2 !== '') {
            let parsedWorkExp = parseInt(str1)
            let parsedTenure = parseInt(str2)
            
            if(parsedWorkExp >= parsedTenure){
                var pattern = /^\d{1,2}(\.\d{1,4})?$/
                return pattern.test(parsedTenure)
            }else {
                return false
            }
        }else {
            return true
        }
    },
    isSourceGetToKnow: function (str) {
        return true
    },
    addToBlog: function (str) {
        if(str !== ''){
            let lowerCaseStr = str.toLowerCase()
            if(lowerCaseStr === 'yes' || lowerCaseStr === 'no'){
                return true
            }else {
                return false
            }
        }else {
            return true
        }
    }
}; 

export const cellValidation = {
    isNumber:function(str, callback) {
        setTimeout(function(){
            var pattern = /^[0-9]+$/;
            if (pattern.test(str) || str === 'sl_no') {
                callback(true);
            }
            else {
                callback(false);
            }
        }, 300);
    },
    isEmailAddress: function (str, callback) {
        setTimeout(function(){
            var pattern =/^[A-Za-z0-9](([_\.\+\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\+\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/;
            if (pattern.test(str) || str === 'user_email') {
                callback(true);
            }
            else {
                callback(false);
            }
        }, 300);
    },
    isFullName: function (str, callback) {
        setTimeout(function(){
            var pattern = /^\s*([A-Za-z]{1,}([\.,] |[-']| ))+[A-Za-z]+\.?\s*$/;
            if (pattern.test(str) || str === 'full_name') {
                callback(true);
            }
            else {
                callback(false);
            }
        }, 300);
    },
    isShortName: function (str, callback) {
        setTimeout(function(){
            if (str.length > 15) {
                callback(false);
            }else if(str === 'short_name') {
                callback(true)
            }
            else {
                callback(true);
            }
        }, 300);
    },
    isGender: function (str, callback) {
        let lowerCaseStr = str.toLowerCase();
        setTimeout(function(){
            if (lowerCaseStr === 'gender' || lowerCaseStr === 'male' || lowerCaseStr === 'female' || lowerCaseStr === 'other' || lowerCaseStr === 'others' || lowerCaseStr === '') {
                callback(true);
            }
            else {
                callback(false);
            }
        }, 300);
    },
    isProperDate: function (str, callback) {
        var pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        setTimeout(function(){
            if (pattern.test(str) || str === 'date_of_birth') {
                callback(true);
            }
            else {
                callback(false);
            }
        }, 300);
    },
    isCountryCode: function (str, callback) {
        setTimeout(function(){
            if(str !== '') {
                var pattern = /^[A-Z]{1,3}$/;
                if (pattern.test(str) || str === 'country_code') {
                    callback(true);
                }
                else {
                    callback(false);
                }
            }else {
                callback(true);
            }
        }, 300);
    },
    isAlternateMail: function (str, callback) {
        setTimeout(function(){
            if(str !== '') {
                var pattern =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (pattern.test(str) || str === 'alternate_email') {
                    callback(true);
                }
                else {
                    callback(false);
                }
            }else {
                callback(true);
            }    
        }, 300);
    },
    isCity: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100){
                    callback(false);                    
                }else {
                    var pattern = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/
                    if (pattern.test(str) || str === 'city') {
                        callback(true);
                    }
                    else {
                        callback(false);
                    }
                }
            }else {
                callback(true);                    
            }
        }, 300);
    },
    isMobileNumber: function (str, callback) {   
        setTimeout(() => {
            if(str !== ''){
                var pattern = /^(\+\d{1,3}[- ]?)?\d{0,17}$/
                if (pattern.test(str) || str === 'mobile') {
                    callback(true);
                }
                else {
                    callback(false);
                }
            }else {
                callback(true);                
            }
        }, 300);             
    },
    isWorkPhone: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                var pattern = /^(\+\d{1,3}[- ]?)?\d{0,27}$/
                if (pattern.test(str) || str === 'work_phone') {
                    callback(true);
                }
                else {
                    callback(false);
                }
            }else {
                callback(true);                
            }
        }, 300);
    },
    isOccupation: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false);                    
                }else if(str === 'occupation'){
                    callback(true)
                }else {
                    callback(true);
                }
            }else {
                callback(true);                
            }
        }, 300);
    },
    isDesignation: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false);                    
                }else if(str === 'designation'){
                    callback(true)
                }else {
                    callback(true);
                }
            }else {
                callback(true);                
            }
        }, 300);
    },
    isWorkExperience: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                var pattern = /^\d{1,2}(\.\d{1,4})?$/
                if(pattern.test(str) || str === 'work_experience'){
                    callback(true)                    
                }else {
                    callback(false)
                }
            }else {
                callback(true)
            }
        }, 300);
    },
    marriedState: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                let lowerCaseStr = str.toLowerCase()
                if(lowerCaseStr === 'marital_status' || lowerCaseStr === 'single' || lowerCaseStr === 'divorced' || lowerCaseStr === 'married' || lowerCaseStr === 'widow'){
                    callback(true)
                }else {
                    callback(false)
                }
            }else {
                callback(true)                
            }
        }, 300);
    },
    sendNotification: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                let lowerCaseStr = str.toLowerCase()
                if(lowerCaseStr === 'send_notifications' || lowerCaseStr === 'no' || lowerCaseStr === 'yes'){
                    callback(true)
                }else {
                    callback(false)
                }
            }else {
                callback(true)                
            }
        }, 300);
    },
    numberOfChildren: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                let numberStr = parseInt(str)
                if(numberStr > 50 || numberStr < 0) {
                    callback(false)
                }else if(str === 'no_of_children'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else {
                callback(true)                
            }
        }, 300);
    },
    familyType: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                let lowerCaseStr = str.toLowerCase()
                if(lowerCaseStr === 'family_type' || lowerCaseStr === 'nuclear' || lowerCaseStr === 'joint' || lowerCaseStr === 'extended'){
                    callback(true)
                }else {
                    callback(false)
                }
            }else {
                callback(true);
            }
        }, 300);
    },isHobbies: function (str, callback){
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 500) {
                    callback(false)
                }else if(str === 'hobbies'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else {
                callback(true)
            }
        }, 300);
    },annualIncome: function (str, callback) {
        setTimeout(() => {
            if(str !== '') {
                if(str === 'annual_income' || str === '< $100,000' || str === '$100,000 - $250,000' || str === '$250,000 - $500,000' || str === '$500,000 - $1million' || str === '> $1million' ){
                    callback(true)
                }else {
                    callback(false)
                }
            }else {
                callback(true)
            }
        }, 300);
    },isPreviousAssessment: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 500) {
                    callback(false)
                }else if(str === 'previous_assessments'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else { 
                callback(true)
            }
        }, 300);
    },isDepartment: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false)
                }else if(str === 'department'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else { 
                callback(true)
            }
        }, 300);
    },isLocation: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false)
                }else if(str === 'location'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else { 
                callback(true)
            }
        }, 300);
    },highestEducation: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false)
                }else if(str === 'highest_education'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else { 
                callback(true)
            }
        }, 300);
    },isIndustry: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false)
                }else if(str === 'industry'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else { 
                    callback(true)
            }
        }, 300);
    },isQualification: function (str, callback) {
        setTimeout(() => {
            if(str !== ''){
                if(str.length > 100) {
                    callback(false)
                }else if(str === 'qualification'){
                    callback(true)
                }else {
                    callback(true)
                }
            }else { 
                callback(true)
            }
        }, 300);
    },
    isSourceGetToKnow: function (str, callback) {
        if(str === 'source_get_to_know'){
            callback(true)
        }else {
            callback(true)
        }
    },
    addToBlog: function (str, callback) {
        if(str !== ''){
            let lowerCaseStr = str.toLowerCase()
            if( lowerCaseStr === 'yes' || lowerCaseStr === 'no' || lowerCaseStr === 'add_to_blog' ){
                callback(true)
            }else {
                callback(false)
            }
        }else {
            callback(true)
        }
    }
}



// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/validation.js